import { Button } from "@workspace/ui/components/button";
import { Header } from "@/components/quiz/explainers/header";
import Image from "next/image";

interface IExplainer {
  title: string;
  image: string;
  values: {
    title: string;
    color: string;
    description: string;
  }[];
  handleNext: () => void;
}
export function TryingDurationExplainer2({
  title,
  image,
  values,
  handleNext,
}: IExplainer) {
  return (
    <>
      <div className="flex flex-col flex-1 gap-[10px] md:gap-6 overflow-y-auto min-h-0 pb-12">
        <Header title={title} />
        <div>
          <div className="bg-[#F3F4ED] rounded-[16px] pb-4">
            <div className="relative w-full h-[348px]">
              <Image
                src={image}
                alt="hormone-graph"
                fill
                className="object-contain"
              />
            </div>
            <div className="grid grid-cols-2 gap-6 px-4 md:px-16">
              {values.map((value, index) => (
                <div key={value.title} className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <div
                      className="w-3 h-3 rounded-[2px]"
                      style={{ backgroundColor: value.color }}
                    />
                    <p className="text-primary title-14"
                      id={`question-option-${index}`}
                      data-testid={`question-option-${index}`}
                    >
                      {value.title}
                    </p>
                  </div>
                  <p className="text-muted-foreground title-12"
                    id={`question-option-description-${index}`}
                    data-testid={`question-option-description-${index}`}
                  >
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="sticky bottom-0 flex flex-col gap-3 pb-6">
        <Button onClick={handleNext} variant="default" className="w-full shrink-0">Learn More</Button>
      </div>
    </>
  );
}
